import {runValidations, runValidationsAfterChange, clearValidations} from '../validationsService/validationsService';

const validationsEventHandler = (RMI) => (e) => {
    const value = e.target.value;
    const compId = e.syntheticEvent.id;

    runValidationsAfterChange(RMI, compId, value);
};

const updateValidationState = (RMI, compId) => runValidations(RMI, compId);

const valueValidatableInitialize = (RMI, contextId, compId) => {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

const valueValidatableClearance = (RMI, contextId, compId) => clearValidations(compId);

export {valueValidatableInitialize,
    valueValidatableClearance
};
